<style scoped>

  .about {
    text-align: center;
    margin-top: 45px;
    padding: 0.5rem 1rem;
    max-width: 100vw;
    margin-bottom: 16px;
  }

  img {
    max-width: 90vw;
    margin-top: 16px;
  }

  .name {
    font-family: rosita, Helvetica, Arial, sans-serif;
    font-size: 3rem;
    letter-spacing: 1px;
    text-transform: capitalize;
  }

  .contact-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
  }

  .contact-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    color: rgba(0, 0, 0, 1);
    font-size: 1rem;
    text-transform: none;
    max-width: 700px;
    padding: 0 32px;

  }

  .contact-data span {
    margin-top: 10px;
  }

  @media (min-width: 610px) {
    .about {
      margin-top: 60px;
    }
    img {
      margin-top: 0;
      max-height: 70vh;
      max-width: 100%;
    }

    .contact-section {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      flex-grow: 1;
      flex-basis: 0;
    }
  }
</style>

<template>
  <div class="about">
    <section class="contact-section">
      <picture>
        <source srcset="@/assets/me_XS.jpg" media="(max-width: 400px)">
        <source srcset="@/assets/me_S.jpg" media="(max-width: 600)">
        <source srcset="@/assets/me_M.jpg" media="(max-width: 800)">
        <img src="@/assets/me_L.jpg">
      </picture>
      <div class="contact-data">
        <span class="name">Maria Jesus</span>
        <span class="description">
        Su trayectoria en el mundo de la moda viene de lejos. Criada entre agujas, tijeras y piezas de tela,
        pronto decidió que ese era su mundo. Vinculada a la costura de la mano de grandes profesionales, tras
        años en la firma Marien, pasó a formar parte del equipo de Jesús del Pozo. Y es ahora, desde su estudio,
        donde hace realidad los deseos de muchas novias e invitadas.
        </span>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'about'
}
</script>
